import { Component, OnInit, Input } from '@angular/core';
import { ChartEvent, ChartType } from '../../../shared/chartist.component';
import * as Chartist from 'chartist';
import { IAccount } from '../../../../interfaces/graph-types';
import { AccountService } from '../../../../services/account.service';

export interface Chart {
  type: string;
  data: Chartist.IChartistData;
  options?: any;
  responsiveOptions?: any;
  events?: ChartEvent;
}

@Component({
  selector: 'account-preview-chart',
  template: require('./account-preview-chart.component.pug'),
  styles: [require('./account-preview-chart.component.css').toString()],
})
export class AccountPreviewChartComponent implements OnInit {
  @Input('account')
  account: IAccount;

  public type: ChartType;
  public events: ChartEvent;
  public options: any;
  accsub: any = null;
  chartist: any = null;

  loading = true;

  // -------------------------------------------------------------------
  constructor(private accountService: AccountService) {
    this.options = {
      axisY: { onlyInteger: true },
      plugins: [Chartist.plugins.tooltip()],
    };
  }

  // -------------------------------------------------------------------
  ngOnInit() {
    this.accountService.getCharts(this.account.id).subscribe(res => {
      // this.chartist = res.chartist;
      this.type = 'Line';
      this.events = { draw: this.chartDrawEvent };
      this.loading = false;
    });
  }

  // -------------------------------------------------------------------
  ngOnDestroy() {}

  // -------------------------------------------------------------------
  chartDrawEvent(context: any): void {
    //console.warn('Event');
    //console.warn(context);
    if (context.seriesIndex == 0) {
      // previous period
      context.element._node.style.stroke = '#dcdcdc';
    }
    if (context.seriesIndex == 1) {
      // current period
      context.element._node.style.stroke = '#1694ff';
    }
    if (context.seriesIndex == 2) {
      // current period replies
      context.element._node.style.stroke = '#21d43c';
    }
  }
}
